import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  cursor: pointer;
`;

export const Checkbox = styled.div`
  display: flex;

  border-radius: 4px;

  background-color: #ffffff;

  svg {
    inline-size: 18px;
    block-size: 18px;
  }
`;

export const Content = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const BoldWord = styled.span`
  font-weight: 700;
`;
